import { darkenColor } from 'apps/dashboard/utils/helpers';
import { updateBookingDriver } from '../../../store/Bookings/actions';
import { RootReducerState } from '../../../store/reducer';
import moment from 'moment-timezone';
import {
  BsFillArrowDownRightCircleFill,
  BsFillArrowUpRightCircleFill,
} from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';

export default function InfoTiles({ booking }) {
  return (
    <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-4">
      <FromTile booking={booking} />

      <ToTile booking={booking} />
    </div>
  );
}

const FromTile = ({ booking }) => {
  const dispatch = useDispatch();

  const { drivers } = useSelector(
    (state: RootReducerState) => state.dashboard.selectedBranch
  );
  return (
    <div className="rounded border border-gray-300 bg-gray-50 px-5 py-3">
      <h5 className="mb-3 font-medium text-gray-600">From:</h5>
      <div className="flex items-center">
        <BsFillArrowDownRightCircleFill
          className={`mr-5 h-12 w-12 flex-none`}
          style={{ color: booking.branch.branch_colour }}
        />
        <div>
          <h6
            className={`font-medium`}
            style={{ color: booking.branch.branch_colour }}
          >
            {booking.branch.name}
          </h6>
          <span className="text-sm text-gray-600">
            {booking.branch.address.formatted_address}
          </span>
        </div>
      </div>
      <span className="my-5 block text-sm font-medium text-gray-700">
        Pickup before:{' '}
        {moment(booking.start_time)
          .tz(booking.branch.timezone)
          .format('DD MMMM HH:mm A')}
      </span>
      <div className="relative flex rounded">
        <div className="z-10 w-full">
          <div className="flex w-full items-center">
            <div className="mr-4">
              <div
                style={{
                  backgroundColor: booking.colour,
                }}
                className={`flex h-10 w-10 items-center justify-center rounded-full border-2 border-black text-center text-white`}
              >
                {booking.driver?.name.charAt(0)}
              </div>
            </div>
            <span className="text-sm text-gray-900">
              {booking.driver?.name ??
                drivers.find((d) => d.id === booking.driver_id)?.name ??
                'No driver assigned'}
            </span>
          </div>
          <div className="mt-1 flex justify-items-center">
            <select
              onChange={(e) =>
                dispatch(
                  updateBookingDriver(
                    booking.branch.id,
                    booking,
                    parseInt(e.target.value)
                  )
                )
              }
              className="block w-full appearance-none border-0 border-b border-gray-300 bg-transparent pl-0 pr-2 text-gray-500 placeholder-gray-400 focus:border-gray-500 focus:outline-none focus:ring-transparent sm:text-sm"
            >
              <option value="">Update driver</option>
              {drivers.length > 0 &&
                drivers.map((val, index) => {
                  return (
                    <option key={index} value={val.id}>
                      {val.name}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

const ToTile = ({ booking }) => {
  return (
    <div
      className={`rounded-md border border-gray-300 bg-opacity-50 px-5 py-3 shadow-sm`}
      style={{
        backgroundColor: darkenColor(booking.branch.branch_colour, 50),
      }}
    >
      <h5 className="mb-3 font-medium text-gray-600">To:</h5>
      <div className="flex items-center">
        <BsFillArrowUpRightCircleFill
          className={`mr-5 h-12 w-12 flex-none`}
          style={{ color: booking.branch.branch_colour }}
        />
        <div>
          <h6
            className={`font-medium`}
            style={{ color: booking.branch.branch_colour }}
          >
            {booking.delivery_location.name}
          </h6>
          <span className="text-sm text-gray-600">
            {booking.delivery_location.address}
            {', '}
            {booking.delivery_location.city}
          </span>
        </div>
      </div>
      <span className="my-2 block text-sm font-medium text-gray-800">
        Deliver by:{' '}
        {moment(booking.delivery_arrival_time)
          .tz(booking.branch.timezone)
          .format('DD MMMM HH:mm A')}
      </span>
      <span className="my-2 block text-sm font-medium text-gray-800">
        {booking.anytime ? (
          <span className="inline-flex items-center rounded-full bg-orange-100 px-2.5 py-0.5 text-sm font-medium text-orange-800">
            A
          </span>
        ) : (
          <></>
        )}
      </span>
      <div className="mb-2">
        <div className="flex flex-col">
          <span className="text-sm text-gray-400">Loading Instructions</span>
          <div className="text-sm">
            {booking.loading_instructions ?? 'No instructions provided'}
          </div>
        </div>
      </div>
      <div>
        <div className="flex justify-between gap-2">
          <span className="text-sm text-gray-400">Delivery Instructions</span>
        </div>
        {booking.delivery_location.instructions !== null ? (
          <textarea
            className="block w-full appearance-none border-0 border-b-2 border-gray-300 bg-transparent px-0 py-2 placeholder-gray-400 focus:border-gray-500 focus:outline-none focus:ring-transparent sm:text-sm"
            name="delivery_instructions"
          >
            {booking.delivery_location.instructions == '-'
              ? booking.delivery_instructions ??
                booking.delivery_location.instructions
              : '-'}
          </textarea>
        ) : (
          <div className="text-sm">
            {booking.delivery_instructions ?? 'No instructions provided'}
          </div>
        )}
      </div>
    </div>
  );
};
